<template>
  <div>
    <v-menu
      class="v-menu"
      left
      origin="center center"
      transition="scale-transition"
      :data-testid="`${params.testId ? `${params.testId}__` : ''}MenuItem`"
      v-if="getParams"
    >
      <v-btn slot="activator" icon>
        <v-icon color="#526da5">more_vert</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile style="height:40px;" v-if="getParams">
          <v-list-tile-avatar style="min-width: 35px;">
            <v-btn small icon @click="handleItemClick(Accion.Editar)">
              <v-icon small color="#526da5">edit</v-icon>
            </v-btn>
          </v-list-tile-avatar>
          <v-list-tile-title
            style="cursor:pointer;font-size:13px;;color:rgba(0,0,0,0.7);"
            @click="handleItemClick(Accion.Editar)"
            >Editar</v-list-tile-title
          >
        </v-list-tile>
        <v-list-tile style="height:40px;" v-if="getParams">
          <v-list-tile-avatar style="min-width: 35px;">
            <v-btn small icon @click="handleItemClick(Accion.Eliminar)">
              <v-icon small color="#526da5">delete</v-icon>
            </v-btn>
          </v-list-tile-avatar>
          <v-list-tile-title
            style="cursor:pointer;font-size:13px;;color:rgba(0,0,0,0.7);"
            @click="handleItemClick(Accion.Eliminar)"
            >Eliminar</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-menu
      class="v-menu"
      left
      origin="center center"
      transition="scale-transition"
      :data-testid="`${params.testId ? `${params.testId}__` : ''}MenuItem`"
      v-if="params.typeModal == 'cotizacion'"
    >
      <v-btn slot="activator" icon>
        <v-icon color="#526da5">more_vert</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          style="height:40px;"
          v-if="
            params.typeModal == 'cotizacion' &&
              (params.data.estado == 'ENVIADA' ||
                params.data.estado == 'POR ENVIAR')
          "
        >
          <v-list-tile-avatar style="min-width: 35px;">
            <v-btn small icon @click="handleItemClick_2(Accion.VerPdf)">
              <v-icon small color="#526da5">{{ btnVerIcon }}</v-icon>
            </v-btn>
          </v-list-tile-avatar>
          <v-list-tile-title
            style="cursor:pointer;font-size:13px;;color:rgba(0,0,0,0.7);"
            @click="handleItemClick_2(Accion.VerPdf)"
            >Ver PDF</v-list-tile-title
          >
        </v-list-tile>
        <v-list-tile
          style="height:40px;"
          v-if="
            params.typeModal == 'cotizacion' &&
              params.data.estado == 'PENDIENTE'
          "
        >
          <v-list-tile-avatar style="min-width: 35px;">
            <v-btn small icon @click="handleItemClick_2(Accion.Editar)">
              <v-icon small color="#526da5">edit</v-icon>
            </v-btn>
          </v-list-tile-avatar>
          <v-list-tile-title
            style="cursor:pointer;font-size:13px;;color:rgba(0,0,0,0.7);"
            @click="handleItemClick_2(Accion.Editar)"
            >Editar</v-list-tile-title
          >
        </v-list-tile>
        <v-list-tile
          style="height:40px;"
          v-if="
            params.typeModal == 'cotizacion' && params.data.estado == 'ENVIADA'
          "
        >
          <v-list-tile-avatar style="min-width: 35px;">
            <v-btn small icon @click="handleItemClick_2(Accion.Enviar)">
              <v-icon small color="#526da5">email</v-icon>
            </v-btn>
          </v-list-tile-avatar>
          <v-list-tile-title
            style="cursor:pointer;font-size:13px;;color:rgba(0,0,0,0.7);"
            @click="handleItemClick_2(Accion.Enviar)"
            >Reenviar cotización</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  EstadoEntidad,
  EstadoAceptarInformacion,
  EstadoCompartirInformacion,
  TipoUsuario,
  TipoRol,
  ServicioProxy,
} from '@/config/enums';
import { actionsEvent, actionsEvent_2 } from '@/setup';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';
import { Accion } from '@/config/enums';
import { CodigoAccion } from '../views/base/VariablesPermisos';
import { AxiosVue } from '@/AxiosVue';

export default Vue.extend({
  data: function() {
    return {
      Accion,
      estadoEntidad: EstadoEntidad.Activo,
      enabledDeleteBtn: true,
      enabledEditBtn: true,
      mostrarMenuAcciones: false,
      //botones deben ser variables no props, para cambiar
      //su estado sin necesidad de data computed
      btnDejarDeCompartir: false,
      btnDejarDeRecibir: false,
      btnEliminar: true,
      btnEditar: true,
      btnVerDetalle: true,
      btnVerDetalleText: 'Ver Detalle',
      btnAceptar: false,
      btnRechazar: false,
      btnDesbloquear: false,
      btnCancelar: false,
      btnDesbloquearText: 'Bloquear',
      btnDescargar: false,
      btnCambiarContraseña: false,
      axios: null,
      btnEnviar: false,
      btnEnviarText: '',
      btnDescargarText: '',
      btnVerPdf: false,
      btnVerText: 'Ver PDF',
      btnVerIcon: 'picture_as_pdf',
      btnVerReferencia: false,
      btnVerReferenciaIcon: 'receipt_long',
      btnVerReferenciaText: 'Ver Referencia',
      btnTraza: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    typeModal: {
      type: String,
      detault: '',
    },
  },
  computed: {
    getParams() {
      let params =
        this.params.typeModal == 'detalleCotizacion' &&
        !(
          this.params.data.hasOwnProperty('nombre_solucion') &&
          this.params.data.nombre_solucion.toString() == 'Total' &&
          this.params.data.hasOwnProperty('modalidad') &&
          this.params.data.modalidad.toString() == ''
        );
      console.log(params);
      return params;
    },
  },
  methods: {
    handleItemClick(action) {
      actionsEvent.$emit('actionsEvent', {
        action,
        id:
          action === Accion.Eliminar &&
          this.estadoEntidad == EstadoEntidad.Eliminado
            ? -1
            : this.params.value,
        cellRendererParams: this.params,
      });
    },
    handleItemClick_2(action) {
      actionsEvent_2.$emit('actionsEvent', {
        action,
        id:
          action === Accion.Eliminar &&
          this.estadoEntidad == EstadoEntidad.Eliminado
            ? -1
            : this.params.value,
        cellRendererParams: this.params,
      });
    },
  },
  mounted() {
    if (this.params.data.estado != undefined) {
      this.estadoEntidad = this.params.data.estado;
      if (this.params.data.estado == EstadoEntidad.Eliminado) {
        this.enabledDeleteBtn = false;
      }
    }

    if (
      this.params.eParentOfValue.baseURI.toString().indexOf('funcionalidad') >
      -1
    ) {
      this.btnEliminar = false;
    }
  },
});
</script>
<style scoped>
.v-menu {
  display: block;
}
</style>
